import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Spinner, Avatar } from "@/components/UI";
import api from "@/lib/api";
import { Users } from "lucide-react";

export default function TeamLaporan() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/users")
      .then((r) => setUsers((r.data || []).filter((u) => ["employee", "admin"].includes(u.role))))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;

  return (
    <div className="mx-auto max-w-6xl space-y-6" data-testid="team-laporan-page">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Laporan Tim</h1>
        <p className="text-sm text-slate-400">Klik employee untuk melihat laporan individu.</p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {users.map((u) => (
          <Card
            key={u.id}
            onClick={() => navigate(`/performance/${u.id}`)}
            className="cursor-pointer p-5 transition-colors hover:border-slate-600"
            data-testid={`team-laporan-employee-${u.id}`}
          >
            <div className="flex items-center gap-3">
              <Avatar src={u.avatar_url} name={u.name} size={48} />
              <div>
                <p className="font-medium text-slate-200">{u.name}</p>
                <p className="text-xs text-slate-500">{u.job_title || "Employee"}</p>
              </div>
            </div>
          </Card>
        ))}
        {users.length === 0 && (
          <p className="col-span-full text-sm text-slate-500">Belum ada employee.</p>
        )}
      </div>
    </div>
  );
}
